/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Číselník prostředí sestavené aplikace.
 * @enum {string}
 * @name EnvEnum
 */
export default {
  /** Prostředí pro vývojáře. */
  DEV: 'DEV',
  /** Produkční prostředí. */
  PROD: 'PROD'
};
